exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Button-module__Link___k-y7S {\n\twidth: 100%;\n}\n\n.Button-module__Hidden___nkdsQ {\n  visibility: hidden;\n}\n\n.Button-module__Loader___i1aUW {\n  position: absolute;\n}\n\n.Button-module__ButtonWrap___fzeEd {\n  display: contents;\n}", ""]);

// exports
exports.locals = {
	"Link": "Button-module__Link___k-y7S",
	"Hidden": "Button-module__Hidden___nkdsQ",
	"Loader": "Button-module__Loader___i1aUW",
	"ButtonWrap": "Button-module__ButtonWrap___fzeEd"
};